var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('component-header-index'),_c('div',{staticClass:"container-flex"},[_c('Payment'),_c('div',{staticClass:"pr-list"},[_c('PRBanner')],1)],1),_c('component-footer-index')],1)}
var staticRenderFns = []

export { render, staticRenderFns }